import { createSpkCapitalOneCreditCardTransactionReceipt } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const createCapitalOneReceipt = async (props) => {
  if (!props) {
    console.error('❌ createCapitalOneReceipt: No props provided');
    throw new Error('No props provided for receipt creation');
  }

  console.log('🎯 createCapitalOneReceipt called with props:', {
    ...props,
    // Log only essential fields to avoid clutter
    id: props.id,
    matchStatus: props.matchStatus,
    divisionId: props.divisionId,
    teamMemberId: props.teamMemberId
  });
  
  try {
    const gqlParams = { input: props };
    console.log('📡 Creating GraphQL request with params:', gqlParams);
    
    // Add timeout to prevent hanging
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('GraphQL request timeout after 30 seconds')), 30000);
    });
    
    console.log('🔄 Making GraphQL request...');
    const response = await Promise.race([
      client.graphql({
        query: createSpkCapitalOneCreditCardTransactionReceipt,
        variables: gqlParams
      }),
      timeoutPromise
    ]);
    
    console.log('✅ GraphQL response received');
    
    // Check for GraphQL errors
    if (response.errors && response.errors.length > 0) {
      console.error('❌ GraphQL errors:', response.errors);
      throw new Error(`GraphQL errors: ${JSON.stringify(response.errors)}`);
    }
    
    const receiptId = response.data?.createSpkCapitalOneCreditCardTransactionReceiptTbl?.id;
    if (!receiptId) {
      console.error('❌ No receipt ID in response:', response);
      throw new Error('Receipt creation failed - no ID returned from server');
    }
    
    console.log('🎉 Receipt created successfully with ID:', receiptId);
    return receiptId;
  } catch (err) {
    console.error('❌ createCapitalOneReceipt failed:', {
      message: err.message,
      errors: err.errors,
      data: err.data,
      stack: err.stack
    });
    
    // Re-throw with proper error message
    throw new Error(`Failed to create receipt: ${err.message}`);
  }
};


createCapitalOneReceipt.propTypes = {
  props: PropTypes.shape({
    allSort: PropTypes.string,
    id: PropTypes.string.isRequired,
    plaidCreditCardTransactionId: PropTypes.string,
    capitalOneInstantNotificationId: PropTypes.string,
    teamMemberId: PropTypes.string,
    divisionId: PropTypes.string,
    iftaFuelTaxTrackId: PropTypes.string,
    matchStatus: PropTypes.string,
    qbTransactionEntityId: PropTypes.string,
    isReceiptUploaded: PropTypes.bool,
    quickbooksExpenseId: PropTypes.string,
    clientId: PropTypes.string,
    expenseCategoryId: PropTypes.string,
    unitId: PropTypes.string,
    addedNotes: PropTypes.string,
    hasIssue: PropTypes.bool,
    issue: PropTypes.string,
  }).isRequired,
};


      

      